import { atomWithStorage } from "jotai/utils";

export const PRODUCT_CACHE_TIMESTAMP_KEY = "productCacheTimestamp";

const initialValue = new Date().getTime();

export const productCacheTimestampAtom = atomWithStorage(PRODUCT_CACHE_TIMESTAMP_KEY, initialValue, undefined, {
  getOnInit: true,
});
